export enum ProjectActionPermissionEnum {
  NewFault = 1,
  AddAttachment = 2,
  EditFault = 3,
  DeleteFault = 4,
  EditCtNumber = 5,
  NewActivity = 6,
  EditActivity = 7,
  DeleteActivity = 8,
  ViewActivitiesCO = 9,
  ViewActivitiesCT = 10,
  EditProjectLayout = 11,
  EditProjectFilter = 12,
  EditAssignedStructureOfFault = 13,
  EditWritingTemplate = 14,
  NewCraftInProject = 15,
  DeleteAttachment = 16,
  EditLockedActivities = 17,
  OverrideProjectStatusPermissions = 18,
  MasterDataImportEnabled = 19,
  EditPins = 20,
  DeletePlansIncludingPins = 21,
  DeletePins = 22,
  FetchAndComplementGlobalCompanies = 23,
  DefectPoolsVisible = 24,
  DefectPoolsCreate = 25,
  DefectPoolsUpdate = 26,
  DefectPoolsAddDefects = 27,
  DefectPoolsRemoveDefects = 28,
  DefectPoolsDelete = 29
}
